// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Nu9cHUhRQ7GIF_g_5KjZi","form":"_5MMbOa_bCKGa0OL9cxwMo","input":"_2z4zDcvlBQKx80dBeupJPN","responseContainer":"-DHcfd13oUsFURSRoKRng","loader":"_38MQy3g9SHUx7LZsWfyF30","message":"q3mX-29gOANCgK9xAHfSx","fade-in":"_2bOCt1MrSy2AkUa0Ulr6WM"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Newsletter/Form/styles.css
// module id = 312
// module chunks = 0